import { DefaultTheme } from 'styled-components';
import { rem } from 'polished';
import colors from './colors';

const shadows = {
    xs: '0 1px 3px hsla(220,6%,43%,0.2)',
    sm: '0 4px 6px hsla(220,6%,43%,0.2)',
    md: '0 5px 15px hsla(220,6%,43%,0.2)',
    lg: '0 10px 24px hsla(220,6%,43%,0.2)',
    xl: '0 15px 35px hsla(220,6%,43%,0.2)',
    default: `0 0 0 1px ${colors.neutral[300]}`,
    secondary: `0 0 0 1px ${colors.neutral[500]}`,
    'primary-thin': `0 0 0 1px ${colors.primary[200]}`,
    'accent-thin': `0 0 0 1px ${colors.primary[1000]}`,
    'accent-normal': `0 0 0 2px ${colors.primary[1000]}`,
    'accent-normal-inner': `inset 0 0 0 2px ${colors.primary[1000]}`,
    'accent-heavy': `0 0 0 3px ${colors.primary[1000]}`,
    'error-thin': `0 0 0 1px ${colors.error.main}`,
    'error-normal': `0 0 0 2px ${colors.error.main}`,
    none: 'none',
};

const borders = {
    none: 0,
    default: `1px solid ${colors.neutral[300]}`,
    secondary: `1px solid ${colors.neutral[500]}`,
    dashed: `1px dashed ${colors.neutral[500]}`,
};

const fonts = {
    heading: 'Outfit, system-font, sans-serif',
    body: 'Lato, system-font, sans-serif',
};

const radii = {
    none: '0',
    xs: rem('2px'),
    sm: rem('4px'),
    md: rem('8px'),
    lg: rem('16px'),
    full: rem('9999px'),
};

const theme: DefaultTheme = {
    colors,
    breakpoints: [
        '320px',
        '576px',
        '768px',
        '1080px',
        '1280px',
        '1440px',
        '1588px',
    ],
    shadows,
    borders,
    fonts,
    radii,
};

[
    theme.breakpoints['2xs'],
    theme.breakpoints.xs,
    theme.breakpoints.sm,
    theme.breakpoints.md,
    theme.breakpoints.lg,
    theme.breakpoints.xl,
    theme.breakpoints['2xl'],
] = theme.breakpoints;

theme.breakpoints.fluidStart = theme.breakpoints.sm;

declare module 'styled-components' {
    export interface DefaultTheme {
        colors: typeof colors;
        breakpoints: {
            [index: number]: string;
            '2xs'?: string;
            xs?: string;
            sm?: string;
            md?: string;
            lg?: string;
            xl?: string;
            '2xl'?: string;
            fluidStart?: string;
        };
        shadows: typeof shadows;
        borders: typeof borders;
        fonts: typeof fonts;
        radii: typeof radii;
    }
}

export { theme };
